import React from "react";
import dynamic from "next/dynamic";
import PricingHeader from "./PricingHeader";
import PricingCards from "./PricingCards";
import SalesContact from "./SalesContact";
import ContentWrapper from "./ContentWrapper";
import classes from "./PlanSelectionWrapper.module.css";
import LogService from "../../services/LogService";
import CREDIT_EVENTS from "../../utils/CreditEvents";
import {
  useContactSalesABTest,
  usePlanSelectionSalesContactABTest
} from "../../hooks/useABTest";
import { modalStateValues } from "services/constants";
import useModalStore from "zustandStores/useModalStore";
import ContentWrapperFaq from "./ContentWrapperFaq";
const PricingPerks = dynamic(() => import("./PricingPerks"), {
  ssr: false
});

const PlanSelectionFaq = dynamic(() => import("./PlanSelectionFaq"), {
  ssr: false
});
const PlanSelectionWrapper: React.FC = () => {
  const { shouldShowV2Form } = useContactSalesABTest();
  const { showSalesContactCard, showSalesContact } =
    usePlanSelectionSalesContactABTest();
  const { setModalData } = useModalStore(state => ({
    setModalData: state.setModalData
  }));

  const handleContactSalesClick = () => {
    // Use centralized A/B test logic for event logging
    if (shouldShowV2Form) {
      LogService.log(CREDIT_EVENTS.CONTACT_SALES_CLICKED_V2, {
        source: "plan-selection"
      });
    } else {
      LogService.log(CREDIT_EVENTS.CREDIT_SELECTION_CONTACT_SALES_CLICKED, {
        source: "plan-selection"
      });
    }
    setModalData({
      state: modalStateValues.open,
      type: "CONTACT_SALES_MODAL",
      data: { src: "plan-selection" }
    });
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.backgroundImage} />
      <div className="relative pt-16 md:pt-12 pb-10 md:py-16 tw-root">
        <PricingHeader />
        <PricingCards
          showSalesContactCard={showSalesContactCard}
          onContactSalesClick={handleContactSalesClick}
        />
      </div>
      {/* Show SalesContact below pricing cards for 80% of recruiters */}
      {showSalesContact && (
        <ContentWrapper showTopBorder={true}>
          <SalesContact onContactSalesClick={handleContactSalesClick} />
        </ContentWrapper>
      )}
      <ContentWrapper>
        <PricingPerks />
      </ContentWrapper>
      <ContentWrapperFaq>
        <PlanSelectionFaq />
      </ContentWrapperFaq>
    </div>
  );
};

export default PlanSelectionWrapper;
